import { BrowserRouter as Router, Switch, Route } from 'react-router-dom'
import { useSelector } from 'react-redux'
import Login from './pages/Login'
import LoginLayout from './layout/layouts/LoginLayout'
import PatientLogin from './pages/PatientLogin'
import DefaultLayout from './layout/layouts/DefaultLayout.js'
import Patients from './pages/Patients'
import Doctors from './pages/Doctors'
import Contracts from './pages/Contracts'
import Events from './pages/Events'
import ActiveContracts from './pages/ActiveContracts'
import Administrators from './pages/Administrators'
import Calendar from './pages/Calendar.js'
import PatientsPreview from './pages/PatientsPreview'
import DoctorsPreview from './pages/DoctorsPreview'
import Goodbye from './pages/Goodbye'
import Sandbox from './pages/Sandbox'
import Examinations from './pages/Examinations'
import Images from './pages/Images'
import RoleProtected from '../molecules/RoleProtected'
import DoctorRegister from './pages/DoctorRegister'
import PasswordReset from './pages/PasswordReset'
import PasswordResetCode from './pages/PasswordResetCode'
// import Reports from './pages/Reports'

const Routes = () => {
  const loaded = useSelector((state) => state.user.loaded)

  return loaded ? (
    <Router>
      <Switch>
        <Route path="/login">
          <LoginLayout>
            <Login />
          </LoginLayout>
        </Route>
        <Route path="/goodbye">
          <LoginLayout>
            <Goodbye />
          </LoginLayout>
        </Route>
        <Route path="/password/reset/:code">
          <LoginLayout>
            <PasswordResetCode />
          </LoginLayout>
        </Route>
        <Route exact path="/password/reset">
          <LoginLayout>
            <PasswordReset />
          </LoginLayout>
        </Route>
        <Route path="/patient/login/:code">
          <LoginLayout>
            <PatientLogin />
          </LoginLayout>
        </Route>
        <Route path="/doctor/register/:code">
          <LoginLayout>
            <DoctorRegister />
          </LoginLayout>
        </Route>
        <RoleProtected allowRoles={[1, 2]} path="/patients">
          <DefaultLayout>
            <Patients />
          </DefaultLayout>
        </RoleProtected>
        <RoleProtected allowRoles={[1]} path="/contracts">
          <DefaultLayout>
            <Contracts />
          </DefaultLayout>
        </RoleProtected>
        <RoleProtected allowRoles={[1]} path="/active-contracts">
          <DefaultLayout>
            <ActiveContracts />
          </DefaultLayout>
        </RoleProtected>
        <RoleProtected allowRoles={[1]} path="/events">
          <DefaultLayout>
            <Events />
          </DefaultLayout>
        </RoleProtected>
        <RoleProtected allowRoles={[1]} path="/calendar">
          <DefaultLayout>
            <Calendar />
          </DefaultLayout>
        </RoleProtected>
        <RoleProtected allowRoles={[1]} path="/doctors">
          <DefaultLayout>
            <Doctors />
          </DefaultLayout>
        </RoleProtected>
        <RoleProtected allowRoles={[1]} path="/doctor/:id/:page">
          <DefaultLayout>
            <DoctorsPreview />
          </DefaultLayout>
        </RoleProtected>
        <RoleProtected allowRoles={[1]} path="/administrators">
          <DefaultLayout>
            <Administrators />
          </DefaultLayout>
        </RoleProtected>
        <Route path="/sandbox">
          <DefaultLayout>
            <Sandbox />
          </DefaultLayout>
        </Route>
        <RoleProtected allowRoles={[1]} path="/patient/:id/:page">
          <DefaultLayout>
            <PatientsPreview />
          </DefaultLayout>
        </RoleProtected>
        <RoleProtected allowRoles={[2]} path="/patient/:id/">
          <DefaultLayout>
            <PatientsPreview />
          </DefaultLayout>
        </RoleProtected>
        <RoleProtected allowRoles={[1, 2, 0]} path="/examinations">
          <DefaultLayout>
            <Examinations />
          </DefaultLayout>
        </RoleProtected>
        <RoleProtected allowRoles={[1]} path="/images">
          <DefaultLayout>
            <Images />
          </DefaultLayout>
        </RoleProtected>
        {/* <RoleProtected allowRoles={[1]} path="/reports">
          <DefaultLayout>
            <Reports />
          </DefaultLayout>
        </RoleProtected> */}
      </Switch>
    </Router>
  ) : (
    <>test</>
  )
}

export default Routes
